import { createPopper } from '@popperjs/core';

export default defineNuxtPlugin(() => {
  // Ensure @popperjs/core is imported
  import('@popperjs/core');
  console.log(createPopper);
})